module.exports = __webpack_public_path__ + "static/media/173-mali.771fa8a9.svg";